
import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

// Custom switch with prominent green styling when enabled
const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // Track
      // Subtle blue-grey background, soft blue-or-gray shadow, and border
      // Smooth animated transitions for usability
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-gray-200 dark:border-gray-700 ",
      "transition-colors duration-200 shadow-[0_1px_6px_0_rgba(33,118,167,0.07),0_1.5px_10px_0_rgba(0,0,0,0.035)] bg-gray-100 dark:bg-[#232535] ",
      // Checked state (bright green, clear, slightly elevated)
      "data-[state=checked]:bg-green-500 data-[state=checked]:border-green-500",
      // Unchecked state (more neutral and soft)
      "data-[state=unchecked]:bg-gray-200 dark:data-[state=unchecked]:bg-gray-700 data-[state=unchecked]:border-gray-300 dark:data-[state=unchecked]:border-gray-600",
      className,
    )}
    ref={ref}
    {...props}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        // Thumb
        "pointer-events-none block h-5 w-5 rounded-full bg-white",
        // Soft, premium shadow like demo (see blue shadow above)
        "shadow-[0_2px_8px_0_rgba(145,170,220,0.14)] ring-0",
        "transition-transform duration-200",
        "data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
